import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import PurchaseOrder from './purchase-order/purchase-order'
import PurchaseSupplier from './purchase-supplier/purchase-supplier'

const path = '/main/goods/purchaseManage'

export const GOODS_PURCHASE_ORDER = path + '/purchaseOrder'
export const GOODS_SUPPLIER = path + '/supplier'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/purchaseOrder'} component={PurchaseOrder}></Route>
            <Route path={props.match.path + '/supplier'} component={PurchaseSupplier}></Route>
            {/* <Redirect to={GOODS_GOODS_LIBRARY}></Redirect> */}
        </Switch>
    )
}
